import React, { useEffect, useState } from "react";
import { api } from "../api/api";

export default function News() {
  const [news,    setNews]    = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.news.getAll(true)
      .then(setNews)
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  return (
    <div className="container" style={{ maxWidth: 800 }}>
      <h2 className="section-title" style={{ marginTop: "1rem" }}>📰 Neuigkeiten vom Hof</h2>

      {loading && (
        <div style={{ textAlign: "center", color: "#888", padding: "3rem" }}>Wird geladen...</div>
      )}

      {!loading && news.length === 0 && (
        <div className="card" style={{ textAlign: "center", color: "#888", padding: "2rem" }}>
          Aktuell keine Neuigkeiten vorhanden.
        </div>
      )}

      <div style={{ display: "flex", flexDirection: "column", gap: "1.5rem", marginTop: "1.5rem" }}>
        {news.map(n => (
          <div key={n.newsId} className="card" style={{ border: "1.5px solid #a5d6a7", padding: 0, overflow: "hidden" }}>
            {n.bildBase64 && (
              <img src={n.bildBase64} alt={n.titel}
                style={{ width: "100%", maxHeight: 280, objectFit: "cover", display: "block" }} />
            )}
            <div style={{ padding: "1.25rem" }}>
              <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", gap: "1rem", flexWrap: "wrap" }}>
                <h3 style={{ color: "#1b5e20", margin: 0, fontSize: "1.2rem" }}>{n.titel}</h3>
                <small style={{ color: "#aaa", flexShrink: 0 }}>
                  {n.erstelltAm ? new Date(n.erstelltAm + "T00:00:00").toLocaleDateString("de-DE", { day: "2-digit", month: "long", year: "numeric" }) : ""}
                </small>
              </div>
              <p style={{ color: "#444", marginTop: "0.75rem", lineHeight: 1.7, whiteSpace: "pre-wrap" }}>{n.inhalt}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
